module.exports = __webpack_public_path__ + "static/media/Portrait-10260.cc458881.jpg";